module.exports = __webpack_public_path__ + "img/notepad.1364eec8.svg";